module.exports = __webpack_public_path__ + "img/24_26.d499db30.png";